import LevelSwitch from '@Guidelines/Component/LevelSwitch';
import PageContainer from '@Guidelines/Layout/PageContainer';
import PageHeader from '@Guidelines/Layout/PageHeader';
import DocumentTemplatesNotifications from '@UI/Pages/DocumentTemplates/Shared/DocumentTemplatesNotifications';
import DocumentTemplatesHeaderActions from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/DocumentTemplatesHeaderActions';
import OrganizationDocumentTemplatesContent from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/OrganizationDocumentTemplatesContent';
import ArchiveDocumentTypeConfirmationDialog from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/ConfirmationDialogs/ArchiveDocumentTypeConfirmationDialog';
import DocumentTemplateEditSidebar from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sidebars/DocumentTemplateEditSidebar';
import DocumentTemplateHistorySidebar from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sidebars/DocumentTemplateHistorySidebar';
import DocumentTemplateUploadSidebar from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sidebars/DocumentTemplateUploadSidebar';
import DocumentTypeSidebar from '@UI/Pages/DocumentTemplates/OrganizationDocumentTemplates/Sidebars/DocumentTypeSidebar';
import useAccessibleNavigationLevels from '@UI/Hooks/useAccessibleNavigationLevels';
import * as React from 'react';

/**
 * Assembles the screen: header, the data-owning `OrganizationDocumentTemplatesContent`, the four
 * sidebars (upload, edit, history and document-type creation/rename — each auto-contained, reads its
 * own signal), the document-type archive confirmation, and the notifications shared with the
 * facility screen. The header's own action button is `DocumentTemplatesHeaderActions`, which reads
 * the active tab itself rather than taking it as a prop.
 */
const OrganizationDocumentTemplatesPage: React.FC = () => {
	const levels = useAccessibleNavigationLevels('document-templates');

	return (
		<PageContainer>
			<PageHeader
				eyebrow="CONFIGURATION"
				title="Gabarits de documents"
				actions={
					<React.Fragment>
						<DocumentTemplatesHeaderActions />
						<LevelSwitch ariaLabel="Niveau des gabarits" levels={levels} />
					</React.Fragment>
				}
			/>
			<OrganizationDocumentTemplatesContent />
			<DocumentTemplateUploadSidebar />
			<DocumentTemplateEditSidebar />
			<DocumentTemplateHistorySidebar />
			<DocumentTypeSidebar />
			<ArchiveDocumentTypeConfirmationDialog />
			<DocumentTemplatesNotifications />
		</PageContainer>
	);
};

export default OrganizationDocumentTemplatesPage;
